module.exports = __webpack_public_path__ + "img/cover.ef8d661d.png";